<template>
    <div>
        <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='添加通知邮箱' }" v-has="'btn_add'"  > 添加邮箱
        </a-button>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"  >
          <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record)" :disabled="!$_has('btn_status')"  :checked="text==1?true:false"/>
      </span>
            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>
        <a @click="(record)=>{visibleForm = true; titleForm='修改通知邮箱'; editId=text.id ; }" v-has="'btn_edit'">编辑<a-divider type="vertical"/></a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm(record)"
                  @cancel="()=>{}"
          >
   <a v-has="'btn_delete'">删除</a>
  </a-popconfirm>
      </span>
        </a-table>
              <NotificationForm :visible="visibleForm" :title="titleForm" :editId="editId"
                        @changVisible=" () => { this.visibleForm = false;this.editId=''; this.getList()}  "/>

    </div>

</template>

<script>
    import API from "./api";
    import NotificationForm from "./components/notificationForm"
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [
        {
            title: "ID",
            dataIndex: "id",
            width: "10%",
            ellipsis: true,
            key: "id"
        },
        {
            title: "通知类型",
            dataIndex: "type_name",
            ellipsis: true,
            width: "15%",
            key: "type_name"
        },
        {
            title: "用户名",
            dataIndex: "username",
            ellipsis: true,
            key: "username"
        },
        {
            title: "发件人",
            dataIndex: "name",
            ellipsis: true,
            key: "name"
        },
        {
            title: "状态",
            key: "status",
            width: "150px",
            dataIndex: "status",
            scopedSlots: {customRender: "status"}
        },
        {
            title: "操作",
            key: "action",
            width: "200px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: 'index',
        data() {
            return {
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                visibleForm: false,
                titleForm: "",
                loading: true,
                editId: null,
                jurisdictionId: null,
                visibleJurisdiction: false,
                data: [],
                columns,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/UserBackground/NotificationEmail"; //设置左侧导航2-2 active
        },
        components: {NotificationForm},
        methods: {
            getList() {
                API.notificationEmail.GET_LIST().then(res => {
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.data = res.data.data.data
                    this.loading = false
                })
            },

            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                API.notificationEmail.CHANG_STATUS([Json]).then(res => {
                    this.getList()
                })
            },
            confirm(row) {
                removeById(API.notificationEmail.DELE, [row.id]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
        },
        mounted() {
            this.getList()
        }

    }
</script>
